class TrueCentroidResultErrorObject {
    code;
    details;
    message;
}
export class TrueCentroidResultsModel {
    results;
    messages;
    error;
    constructor() { }
    deserialize(input) {
        Object.assign(this, input);
        return this;
    }
}
